import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '../../../components/modal';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';
import AccessForbidden from '../../../components/access-forbidden-container';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';

import {connect} from 'react-redux';

let contextList;

class ManageContext extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
      menuOpenId: null,
      dbFilterCriteria:"",
      emptyState:"You do not have any Context Setup.",
      deleteVal:"",
      modalOpen:false,
      modalTitle:"",
      modalContent:"",
      modalPrimaryButton:"",
      modalSecondaryButton:""
    };
  }


componentDidMount=()=>{
  this.setState({
    dbFilterCriteria:""
  });
}




editContext = (context) => {
    this.props.onClick({context});
}

modalClose=()=>{
  this.setState({
    modalOpen:false
  });
}

modalConfirm=()=>{

  this.setState({
    modalOpen:false
  });
  let deleteObj={
      id:this.state.deleteVal.connId,
      name: this.state.deleteVal.name
  }
  this.props.deleteContext(deleteObj);
}

deleteItem = (item) => {
    //this.props.getRuleSetContent(value);
    //this.props.onClick(value);
    this.setState({
      modalOpen:true,
      modalTitle:"Delete Context",
      modalContent:"Are you sure you want to delete \""+item.name+"\"?",
      modalPrimaryButton:"Yes",
      modalSecondaryButton:"No",
      modalState:"delete",
      deleteVal:item
    });
}

  createNewContext = () => {
    this.props.onClick('new');
}





   render() {






     const {isLoading} = this.props;
     let manageContent,contextListContent;

     if(isLoading.includes('contextlist')){
       manageContent=<Preloader loading={true} /> ;
     }
     else if(this.props.contextList !== undefined){

      if(this.props.contextList===false){
        manageContent=<AccessForbidden message="Sorry, you don't have access to this. Please contact your admin." />
      } else{
      const filterCriteria=this.state.dbFilterCriteria;
      contextList = this.props.contextList.filter(function (e) {  return e.contextName.toLowerCase().includes(filterCriteria.toLowerCase()); } );


      if(contextList.length>0){
        contextListContent=<table className='manage-ruleset-table'>
        <tbody>
             {contextList.map((context,index) => <tr key={index}>
               <td onClick={this.editContext.bind(this,context)} className='user' >{context.contextName}</td>
               <td>{context.desc}</td>
               <td>
               <div className='actions-menu'>
                 <IconButton onClick={(e) => this.setState({ menuAnchorEl: e.currentTarget, menuOpenId: index })}>
                   <i className='material-icons'>more_horiz</i>
                 </IconButton>
                 <Menu 
                   anchorEl={this.state.menuAnchorEl} 
                   open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === index} 
                   onClose={() => this.setState({ menuAnchorEl: null, menuOpenId: null })}
                   anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                   transformOrigin={{horizontal: 'right', vertical: 'top'}}
                 >
                   <MenuItem className='wl-group-card-menu'
                   onClick={this.deleteItem.bind(this,context)}>Delete</MenuItem>
               </Menu>
               </div>
                </td>
               </tr>)}
       </tbody>
        </table>
      }else{
        contextListContent=<EmptyState className="margin-top-0" message={this.state.emptyState} />
      }
       manageContent=<Row>

       <Col sm={6} xs={6}>{contextListContent}</Col>
       <Col sm={4} xs={6} className="manage-rule-buttons">

          <Button href=""  onClick={this.createNewContext.bind(this)} className='createruleset-button'>Add a new context</Button>
       </Col>

       </Row>
     }
   }

     return (
       <div>
       <Modal
        open={this.state.modalOpen}
        title={this.state.modalTitle}
        content={this.state.modalContent}
        primaryButton={this.state.modalPrimaryButton}
        secondaryButton={this.state.modalSecondaryButton}
        close={this.modalClose}
        confirm={this.modalConfirm}
        />
       <div className="manage-ruleset margin-top-30">

       {manageContent}

       </div>

         </div>

     );
   }
}


const mapStateToProps = (state) => {
  return{
    errors: state.contextReducer.errorMessage
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {

  }
}


export default connect(mapStateToProps,mapDispatchToProps) (ManageContext);
